import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { RoleForm } from "./RoleForm";
import { axiosNewInstance } from "../../config/Api";
import { useSelector } from "react-redux";
import "./role.scss";
import LangData from "../common/LangData";

export default function Role() {
  const user = useSelector((state) => state?.user);
  const history = useHistory();
  const [showForm, setShowForm] = useState(false);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ search: "", status: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [editRole, setEditRole] = useState({});
  const token = localStorage.getItem("authToken");

  // Check if user has permission to add a role
  const hasAddRolePermission =
    user?.loginData?.some(
      (p) => p.permission_id === 6 || user?.loginuser?.id === 1
    ) || user?.loginuser?.id === 1;

  // Check if user has permission to edit a role
  const hasEditPermission = (userdata) =>
    user?.loginData?.some((p) => p.permission_id === 7) ||
    user?.loginuser?.id === 1;

  const fetchRoles = async (page = 1) => {
    const FETCH_ROLE_URL = "/api-app/get-roles";
    setLoading(true);
    try {
      const response = await axiosNewInstance.post(
        FETCH_ROLE_URL,
        {
          page,
          name: filters.search || undefined,
          status: filters.status ? Number(filters.status) : undefined,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const roleData = response.data?.data?.roles || {};
      setRoles(roleData?.data || []);
      setCurrentPage(roleData?.current_page || 1);
      setTotalPages(roleData?.last_page || 1);
    } catch (error) {
      if (
        error.response?.data?.status === 0 &&
        error?.response?.data?.message === "User not authenticated"
      ) {
        localStorage.removeItem("authToken");
        history.push("/login");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (data) => {
    if (hasEditPermission(data)) {
      setShowForm(true);
      setEditRole(data);
    } else {
      alert("You don't have permission to edit this role.");
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const handleFormSubmit = () => {
    fetchRoles();
    setShowForm(false);
    setEditRole({});
  };
  const handleFormCancel = () => {
    fetchRoles();
    setShowForm(false);
    setEditRole({});
  };

  return (
    <div className="container mt-4 roleContainer__area">
      <div
        className={`mb-0 d-flex justify-content-between align-items-center pb-2 bg-white shadow-sm ${showForm ? "d-none" : ""
          }`}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            fetchRoles(1);
          }}
        >
          {!showForm && (
            <div className="input-group">
              <input
                type="text"
                className="form-control rounded"
                placeholder="Role name..."
                value={filters.search}
                onChange={(e) =>
                  setFilters({ ...filters, search: e.target.value })
                }
              />
              <select
                className="form-select px-2 rounded"
                style={{ marginLeft: "10px" }}
                value={filters.status}
                onChange={(e) =>
                  setFilters({ ...filters, status: e.target.value })
                }
              >
                <option value="">All Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
              <button
                className="btn btn-primary ml-2 rounded"
                type="submit"
                disabled={loading}
              >
                <LangData keyname="placeholder_search_box" />
              </button>
            </div>
          )}
        </form>

        <div className="d-flex justify-content-end gap-3">
          {!showForm && hasAddRolePermission && (
            <button
              type="button"
              className="btn btn-primary"
              style={{ backgroundColor: "#004E8F", padding: "8px 25px" }}
              onClick={() => {
                setShowForm(true);
                setEditRole({});
              }}
            >
              Add Role
            </button>
          )}
        </div>
      </div>

      {/* Role Form */}
      {showForm && (
        <div className="mb-3">
          <RoleForm
            editRole={editRole}
            onFormSubmit={handleFormSubmit}
            handleFormCancel={handleFormCancel}
          />
        </div>
      )}

      {/* Role Table */}
      {!showForm && (
        <div className="card">
          <div className="card-header user__table_header text-white">
            <h5 className="mb-0"><LangData keyname="label_role_list" /></h5>
          </div>
          <div className="card-body">
            {loading ? (
              <p>Loading roles...</p>
            ) : (
              <>
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th scope="col"><LangData keyname="label_serial" /></th>
                      <th scope="col"><LangData keyname="label_role_name" /></th>
                      <th scope="col"><LangData keyname="label_status" /></th>

                      <th scope="col" className="text-center">
                        <LangData keyname="label_action" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {roles.length > 0 ? (
                      roles.map((role, index) => (
                        <tr key={role.id}>
                          <td>{index + 1 + (currentPage - 1) * 10}</td>
                          <td>{role.name}</td>
                          <td>
                            {role.status === 1
                              ? "Active"
                              : role.status === 0
                                ? "Inactive"
                                : "Unknown"}
                          </td>

                          {hasEditPermission(role) ? (
                            <td className="text-center">
                              <button
                                className="btn btn-sm btn-outline-warning"
                                onClick={() => handleEdit(role)}
                              >
                                Edit
                              </button>
                            </td>
                          ) : (
                            <td className="text-center">
                              <button
                                disabled={true}
                                className="btn btn-sm btn-outline-warning"
                              >
                                N/P
                              </button>
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="100%">
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: "70px", width: "100%" }}
                          >
                            No roles found.
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {/* Pagination */}
                {roles?.length !== 0 && (
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => fetchRoles(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      Prev
                    </button>
                    <span>
                      Page {currentPage} of {totalPages}
                    </span>
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => fetchRoles(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
